<template>
  <layout name="LayoutDefault">
    <div class="Authors">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row" v-if="author">
            <div class="col-lg-3 col-sm-3">
              <div class="item-image text-center">
                <vue-load-image v-if="author && author[0].image">
                  <img slot="image" v-bind:src="`${IMAGEURL}${author[0].image}`" alt="Author Photo" class="img-responsive" />
                  <img slot="preloader" v-bind:src="`${baseUrl}/assets/img/loader.gif`" title="Loading image..." />
                  <div slot="error">can't load image</div>
                </vue-load-image>
              </div>
            </div>

            <div class="col-lg-9 col-sm-9">
              <div class="mt-3">
                <h2 class="tangon" v-if="author">{{ author[0].author_name }}</h2>
              </div>
              <div class="item-details">
                <div class="item-description" v-html="`${author[0].description}`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content -->
      <div class="container" v-if="author[0].products && author[0].products.length > 0">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="col-lg-12 ">
              <div class="section-header">
                <h3>{{ author[0].author_name }}-এর আরও বই</h3>
              </div>
              <div class="section-items">
                <div class="row">
                  <div v-for="(item, index) in author[0].products" v-bind:key="index" class="col-lg-2 col-sm-6 col-6">
                    <ProductCard :item="item" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import ProductCard from './common/ProductCard.vue';
import VueLoadImage from "vue-load-image";

export default {
  data() {
    return {
      author: [
        {
          author_name: null
        }
      ]
    };
  },
  components: {
    Layout,
    ProductCard,
    "vue-load-image": VueLoadImage
  },
  methods: {
    getAuthor() {
      fetch(this.APIURL + "author-profile/" + this.$route.params.id)
        .then(response => response.json())
        .then(json => {
          this.author = json.data;
          console.log("Author data:", this.author);
          console.log("Image URL:", this.IMAGEURL + this.author[0].image);
        });
    }
  },
  mounted() {
    this.getAuthor();
  }
};
</script>
